import {
  StyledContainer,
  StyledTitle,
  StyledDescription,
  StyledCloseButton,
} from './styles/PreSignupSuccessContent.style'

export const PreSignupSuccessContent = ({ hide }: { hide: () => void }) => {
  return (
    <StyledContainer data-cy="pre-signup-success-content">
      <StyledTitle>Obrigado!</StyledTitle>
      <StyledDescription>
        Entraremos em contato pelo seu telefone para fazer seu cadastro completo!
      </StyledDescription>
      <StyledCloseButton onClick={hide}>Fechar</StyledCloseButton>
    </StyledContainer>
  )
}

export default PreSignupSuccessContent
